import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          if (triggerQuestionSelectMetaList.length === 1) {
            const { categoryName, questionDisplayNumber, selectText } = triggerQuestionSelectMetaList[0]
            return `我们将针对在 ${categoryName} 的第 ${questionDisplayNumber} 问题中选择 '${selectText}' (必答)`
          }

          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `${categoryName} 的第 ${questionDisplayNumber} 问题中选择 '${selectText}' `
            }
          )
          return `我们将针对在 ${messages.join(' ,或者在 ')} (必答)`
        }),
    },
    validation: {
      decimal_max_digit: '请输入保留小数点后{decimalMaxDigit}位的数字。',
    },
  }
}
